import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isRiskIssueType, QUALITY_ISSUE_TYPE } from '../../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import DetailsPanel from '../../../generic/DetailsPanel';
import FossabotInlineTip from '../../../shared/ads/FossabotInlineTip';
import { Section } from '../../../shared/vulns/Drawer';
import DependencyDepthMessage from '../DependencyDepthMessage';

import BaseQualityDescription from './BaseQualityDescription';
import MalwareDescription from './MalwareDescription';
import RiskDescription from './RiskDescription';
import RiskDocs from './RiskDocs';

import styles from '../IssueContent.module.less';

/**
 * Main issue details for quality issues.
 *
 * Displays the reason this issue was raised and the depth at which
 * the source package is used.
 */
const QualityIssueDetailsIssueDetails: VoidFunctionComponent = () => {
  const qualityIssueDetails = useSelector(IssuesV2Store.selectors.getQualityIssueDetails);

  if (!qualityIssueDetails) {
    return null;
  }
  const { depthMessages, type, sourceId, malwareRevisionId } = qualityIssueDetails;

  const shouldShowRiskInfo = isRiskIssueType(type);
  const shouldShowFossabotTip = type === 'outdated_dependency';
  const shouldShowMalwareInfo = type === QUALITY_ISSUE_TYPE.Malware && !!malwareRevisionId;
  const shouldShowBaseInfo = !shouldShowRiskInfo && !shouldShowMalwareInfo;
  const shouldShowDepthMessage = depthMessages && !shouldShowMalwareInfo;

  return (
    <Section>
      <DetailsPanel id="issue-details-quality-details" target="Issue details">
        <div className={styles.issueDetails}>
          {shouldShowMalwareInfo && (<MalwareDescription malwareRevisionId={malwareRevisionId} />)}
          {shouldShowRiskInfo && (<RiskDescription type={type} locator={sourceId} />)}
          {shouldShowBaseInfo && <BaseQualityDescription />}
          {shouldShowDepthMessage && <DependencyDepthMessage depthMessages={depthMessages} />}
          {shouldShowRiskInfo && <RiskDocs type={type} />}
        </div>
        {shouldShowFossabotTip && <FossabotInlineTip />}
      </DetailsPanel>
    </Section>
  );
};

export default QualityIssueDetailsIssueDetails;
